export const QUEUE_CONSTANTS = {
  DEFAULT_ACTIVE_TAB: 'admin',
  DEFAULT_TAB: 'audit_trails',
  METADATA_TYPE: 'queues-types',
  SYSTEM_CONFIGURATION_TABS: 'system-configuration-tabs',
  FILE_DOWNLOAD_PREFIX: 'queue-',
  FILE_FALLBACK_NAME: 'queue',
  CSV_MIME_TYPE: 'text/csv;charset=utf-8;',
  COMPLAINT_HEADERS: 'complaint-header',
  USER_COMMUNICATION: 'lookup-user-communication-headers',
  AUDITLOGS_HEADERS: 'auditTrail-logs',
  USER_EDUCATION: 'user-education-headers',
  USER_EXPERIENCE:'lookup-user-experience-headers'
} as const;

export const SESSION_STORAGE_KEYS = {
  USER: 'user',
  NAVIGATION_DATA: 'navigationData',
  YOUTH_ID: 'youthID',
  YOUTH_NUMBER: 'youthNumber',
  APPLICATION_ID: 'applicationID',
  IS_FIRST_SAVE: 'isFirstSave',
  APPLICATION_TYPE: 'applicationType',
  BACK_TO_HOME: 'backToHome'
} as const;

export const SESSION_KEYS = SESSION_STORAGE_KEYS;

export const SESSION_STORAGE_VALUES = {
  IS_FIRST_SAVE_FALSE: 'false',
  BACK_TO_HOME_PATH: '/pages/my-app'
} as const;

export const BANNER_HEADER_FIELDS = {
  APPLICATION_ID: 'Application ID',
  APPLICATION_TYPE: 'Application Type',
  EDUCATOR_NAME: 'Educator Name',
  DATE_CREATED: 'Date Created'
} as const;

export const CSV_REGEX_PATTERNS = {
  QUOTE_ESCAPE: /"/g,
  QUOTE_REPLACEMENT: '""'
} as const;

export const DATA_GRID_CONSTANTS = {
  DISPLAY_MODE: 'compact',
  METADATA_TYPE: 'queues-types',
  GRID_CONTAINER: 'gridContainer',
  REGISTRATION_TEMPLATE: 'registrationTemplate',
  PDF_TEMP_CONTAINER: 'pdf-temp-container',
  PDF_CONTENT: 'pdf-content',
  DEFAULT_FALLBACK_TEXT: 'You'
} as const;

export const LOCK_STATUS = [
  { CD: 'LOCKED', LONG_NM: 'Locked' },
  { CD: 'UNLOCKED', LONG_NM: 'Unlocked' },
  { CD: 'locked', LONG_NM: 'locked' },
  { CD: 'TEMP_LOCK', LONG_NM: 'TEMP_LOCK' },
] as const;

export const LOCK_STATUS_CODES = {
  LOCKED: 'LOCKED',
  UNLOCKED: 'UNLOCKED',
  LOCKED_LOWERCASE: 'locked',
  TEMP_LOCKED: 'TEMP_LOCK'
} as const;

export const DATE_FIELDS = [
  'Date_Updated',
  'section',
  'added_by',
  'dtEffStartDate',
  'dtEffEndDate',
  'Effective_Start_Date',
  'Effective_End_Date',
  'DateUpdated',
  'Expiration_Date_Rule',
  'date_submitted',
  'due_date',
  'archival_date',
  'Date_Submitted',
  'Due_Date',
  'Archival_Date',
  'created_date',
  'submission_date',
  'Date Created',
  'Date Submitted',
  'Resubmitted Date',
  'Date Updated',
  'DateUpdated',
  'archival_date',
  'date_submitted',
  'due_date',
  'created_date',
  'submission_date',
  'Date Created',
  'Date Submitted',
  'Resubmitted Date',
  'Date Updated',
  'archival_date',
  'date_submitted',
  'due_date',
  'date_sent',
  'transactionDate',
  'invoice_date',
  're_submitted_date',
  'fingerprint_date',
  'uploaded_date'
] as const;

export const DATA_FIELDS = {
  APPLICATION_ID: 'application_id',
  /** Legacy / CMS column key; same cell template as APPLICATION_ID */
  APPLICATION_NUMBER: 'application_number',
  CASE_ID: 'case_id',
  CD_APPLICATION_STATUS: 'application_status',
  CD_APPLICATION_TYPE: 'application_type',
  LOCKED_BY: 'locked_by',
  LOCKED_BY_CAPITAL: 'Locked_by',
  COMPLAINT_STATUS: 'complaint_status',
  EDUCATOR_NAME: 'educator_name'
} as const;

export const CELL_TEMPLATES = {
  STATUS: 'statusTemplate',
  TYPE: 'typeTemplate',
  APP_ID: 'appIdTemplate',
  CASE_ID: 'caseIdTemplate',
  LOCKED_BY: 'lockedByTemplate',
  EDUCATOR_NAME: 'educatorNameTemplate',
  COMPLAINT_FORM_ID: 'complaintIdTemplate',
  EXTENSION_STATUS: 'extensionStatusTemplate',
  ENDORSEMENT_GRADE: 'endorsementGradeTemplate'
} as const;

export const GRID_OPTIONS = {
  COLUMNS: 'columns',
  VISIBLE: 'visible'
} as const;

export const BOOLEAN_VALUES = [
  { CD: 'Y', LONG_NM: 'Yes' },
  { CD: 'N', LONG_NM: 'No' }
] as const;
export const YES_NO = [
  { label: 'Yes', value: 'Y' },
  { label: 'No', value: 'N' }
] as const;

export const SEARCH_CONFIG = {
  IS_SEARCH_ENABLE: true,
  TYPE_STRING: 'string'
} as const;
export const QUEUES_HEADERS = [
  ['Application ID', 'Application Type', 'Date Created', 'Date Submitted', 'Resubmitted Date', 'Application Status']
];

export const queues = [
  'admin', 'analyst', 'doesNotQualify', 'intake', 'deficiency', 'background'
];

/** Fallback matTooltip text for App ID column icons; override via CMS GENERIC MESSAGES (G0029, G0030, G0032, G0086). */
export const APP_ID_ICON_GUIDANCE_FALLBACKS: Record<'G0029' | 'G0030' | 'G0032' | 'G0086', string> = {
  G0029: 'New Update',
  G0030: 'New Document',
  G0032: 'Archived',
  G0086: 'New Profile Update by Staff'
};
export const QUEUES_ADVANCED_SEARCH_FIELDS = [
  { key: 'date_of_birth', fieldName: 'date_of_birth', label: 'Date of Birth', datatype: 'daterange', validation: ['datePattern' as const], pattern: 'date', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false },
  { key: 'ssn_number', fieldName: 'ssn_number', label: 'SSN / ITIN', datatype: 'text', placeholder: 'Enter SSN or ITIN', minLength: 4, maxLength: 11, pattern: 'onlyNumber' },
  { key: 'license_number', fieldName: 'license_number', label: 'License Number', pattern: 'onlyNumber', datatype: 'text', placeholder: 'Enter License Number' },
  { key: 'license_type', fieldName: 'license_type', label: 'License Type', datatype: 'dropdown', options: [], placeholder: 'Enter License Type' },
  { key: 'prior_name', fieldName: 'prior_name', label: 'Prior Name', datatype: 'text', placeholder: 'Enter Prior First or Last Name', allowPartialSearch: true, wildcardSearch: true },
  { key: 'primary_email', fieldName: 'primary_email', label: 'Email', datatype: 'text', pattern: 'email10', placeholder: 'user@example.com', tooltip: 'Enter valid email address', enableInputFocus: true, loadErrorMessages: true },
  { key: 'primary_phone', fieldName: 'primary_phone', label: 'Phone Number', datatype: 'text', pattern: 'onlyNumber', placeholder: 'Enter Phone Number', allowPartialSearch: true, wildcardSearch: true },
  { key: 'institution_name', fieldName: 'institution_name', label: 'Educational Institution', datatype: 'text', placeholder: 'Enter Institution Name' },
  { key: 'updated_date', fieldName: 'updated_date', label: 'Last Updated Date', datatype: 'daterange', validation: ['datePattern' as const], pattern: 'date', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false },
  { key: 'new_document_uploaded', fieldName: 'new_document_uploaded', label: 'New Document Uploaded', datatype: 'daterange', validation: ['datePattern' as const], pattern: 'date', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false },
  { key: 'epp_identifier', fieldName: 'epp_identifier', label: 'EPP Identifier', datatype: 'text', placeholder: 'Enter EPP Identifier' },
];
export const BACKGROUND_ADVANCED_SEARCH_FIELDS = [
  { key: 'fingerprint_date', fieldName: 'fingerprint_date', label: 'Fingerprint Submission Date', datatype: 'daterange', validation: ['datePattern' as const], pattern: 'date', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false },
  { key: 'archival_date', fieldName: 'archival_date', label: 'Archival Date', datatype: 'daterange', validation: ['datePattern' as const], pattern: 'date', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false },
  { key: 'has_suspended_or_revoked_license', fieldName: 'has_suspended_or_revoked_license', label: 'License Revoked/Suspended/Denied (Past)', datatype: 'dropdown', options: YES_NO, placeholder: 'Select Response', info: 'Have you ever had a professional certificate or license revoked, suspended, or denied for cause in any state?', showInfoTooltip: true },
  { key: 'has_cert_or_license_revoked', fieldName: 'has_cert_or_license_revoked', label: 'License Suspended/Revoked (Current)', datatype: 'dropdown', options: YES_NO, placeholder: 'Select Response', info: 'Do you hold an educator license in any state that is currently suspended or revoked?', showInfoTooltip: true },
  { key: 'has_disciplinary_action', fieldName: 'has_disciplinary_action', label: 'Professional Discipline', datatype: 'dropdown', options: YES_NO, placeholder: 'Select Response', info: 'Have you ever received a reprimand or other disciplinary action involving any professional certification or license?', showInfoTooltip: true },
  { key: 'has_criminal_conviction', fieldName: 'has_criminal_conviction', label: 'Criminal Conviction', datatype: 'dropdown', options: YES_NO, placeholder:'Select Response' , info:'Have you ever been convicted of any criminal offense other than a traffic violation?', showInfoTooltip:true },
  { key: 'has_sexual_offense_arrest', fieldName: 'has_sexual_offense_arrest', label: 'Sexual Offense Arrest (Against Minor)', datatype: 'dropdown', options: YES_NO, placeholder: 'Select Response', info: 'Have you ever been arrested for any sexual offense involving a minor or pupil?', showInfoTooltip: true },
  { key: 'has_child_abuse_substantiated', fieldName: 'has_child_abuse_substantiated', label: 'Child Abuse Substantiated', datatype: 'dropdown', options: YES_NO, placeholder: 'Select Response', info: 'Has an allegation of child abuse ever been substantiated against you by a law enforcement agency, child welfare agency, or court?', showInfoTooltip: true }
];
export const ARCHIVAL_DATE_SEARCH_FIELD = { key: 'archival_date', fieldName: 'archival_date', label: 'Archival Date', datatype: 'daterange', validation: ['datePattern' as const], pattern: 'date', placeholder: 'Select Date Range', showCalendarIcon: true, showIcon: true, showOnFocus: true, readonly: true, disabled: false }
export const COMPLAINT_SOURCE = {
  INTERNAL: 'Internal',
  EXTERNAL: 'External'
};
export const COMPLAINT_SECTIONS = [
  'Complaint Details',
  'Complainant Information',
  'Witnesses and Supporting Documentation',
  'Complaint Decision',
  'Complaint Archival',
]
